<template>
 <main-content-layout
    :title="$gettext('OBSERVATION_UNIT')"
    :buttonTitle="$gettext('ADD')"
    :actionButton="openModal"
    buttonIconName="note_add"
  >
  <observation-table
  :tableRegister="tableRegister"
  :datatable="datatable"
  :flOpenModal="flModal"
  @closeModal="closeModal"
  :isConsumerUnit="false"/>
 </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { Dialog } from 'quasar'
import ServiceObservationController from './ServiceObservationController'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import ServiceRequestController from '../../../ServiceRequestController'
import ObservationTable from './ObservationTable.vue'
const { modal } = JtCrud

@Component({
  name: 'ServiceObservation',
  components: { JtDataTable, modal, Dialog, MainContentLayout, ObservationTable },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceObservation extends Vue {
  serviceObservationController = ServiceObservationController.getInstance();
  controller = ServiceRequestController.getInstance();
  datatable = null;
  tableRegister = [];
  flModal = false;
  pageDialog = null;
  forms = null;

  async mounted () {
    const datatables = await this.serviceObservationController.loadDatatable()
    this.datatable = datatables
    this.loadServiceObservations()
  }

  async loadServiceObservations () {
    const registros =
      await this.serviceObservationController.loadDatatableModel({ consumerUnit: this.controller.routerStore.params.consumerUnit })
    this.tableRegister = registros
  }

  async openModal () {
    this.flModal = true
  }

  async closeModal () {
    this.flModal = false
    await this.loadServiceObservations()
  }
}
export default ServiceObservation
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.layout {
  height: 700px;
  background-color: $off-white;
}
.q-btn{
  float: right;
}
</style>
